import { MAIN_CONTENT_ID } from 'components/Layout/Layout';
import { CategoryItem } from 'frontend/types';
import React, { useEffect, useState } from 'react';
import PrimaryNavigation from './PrimaryNavigation/PrimaryNavigation';
import styles from './SiteHeader.module.css';
import classnames from 'classnames';
import Hamburger from 'assets/icons/icons-menu-navigation-menu-dark.svg';
import Logo from 'assets/logo.svg';
import Search from 'icons/search_white.svg';
import SpaLink from 'components/SpaLink/SpaLink';
import { primaryNavigationClick } from 'frontend/utils/analytics/dataLayerDispatchers';
type Props = {
  categoryMenuItems: CategoryItem[];
  minorityLanguageCategories: CategoryItem[];
};
export const RESET_FOCUS_ID = 'resetFocus';
const SiteHeader = ({
  categoryMenuItems,
  minorityLanguageCategories
}: Props) => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  useEffect(() => {
    if (showMobileMenu) {
      // Prevent background scroll when in mobile menu
      document.body.classList.add('noScroll');
    } else {
      document.body.classList.remove('noScroll');
    }
    return () => {
      document.body.classList.remove('noScroll');
    };
  }, [showMobileMenu]);
  return <div className={styles.siteHeader} data-testid="site-header" data-sentry-component="SiteHeader" data-sentry-source-file="SiteHeader.tsx">
      <div className={styles.wrapper}>
        <button id={RESET_FOCUS_ID} tabIndex={-1} aria-hidden={true} className={styles.resetFocusButton} />
        <a className={styles.accessibilityLinks} href={`#${MAIN_CONTENT_ID}`}>
          Till huvudinnehåll
        </a>
        <div className={classnames(styles.menuContainer, {
        [`${styles.hideMenu}`]: !showMobileMenu
      })}>
          <PrimaryNavigation hideMenu={() => setShowMobileMenu(false)} isMenuOpen={showMobileMenu} categoryMenuItems={categoryMenuItems} minorityLanguageCategories={minorityLanguageCategories} data-sentry-element="PrimaryNavigation" data-sentry-source-file="SiteHeader.tsx" />
        </div>
        {!showMobileMenu && <div className={styles.mobileMenuButtonContainer}>
            <button onClick={() => setShowMobileMenu(true)} className={styles.mobileMenuButton} aria-expanded={showMobileMenu} aria-controls="Huvudmeny" aria-label="Öppna huvudmeny">
              <Hamburger aria-hidden className={styles.hamburgerIcon} />
            </button>
            <SpaLink href="/" data-trk-primary-navigation="Logo" onClick={() => primaryNavigationClick('Start')} className={styles.logoLink}>
              <Logo className={styles.logo} focusable="false" role="img" aria-label="UR Play" />
            </SpaLink>
            <SpaLink href="/sok" onClick={() => primaryNavigationClick('Sök')} className={styles.searchIcon}>
              <Search aria-label="Sök" />
            </SpaLink>
          </div>}
      </div>
    </div>;
};
export default SiteHeader;